// REACT
import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

// STYLING
import "./dashboard.css";

// API & FUNCTIONS
import { getAllLists } from "../api-interactions/lists";
import { getCookie, logout } from "../helperFunctions/cookie";

// COMPONENTS
import { Nav } from "./navbar/nav";
import { RegularList } from "./regularList";
import PointLeaderboard from "./pointLeaderboard";
import { TaskManagerList } from "./taskManagmentList";
import { QuickAdd } from "./quickAdd";
import { QuickNotes } from "./quick-notes";
import { Skeleton, Alert } from "@material-ui/lab";
import { Snackbar, Backdrop } from "@material-ui/core";

export const Dashboard = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [success, setSuccess] = useState(searchParams.get("success") || "");
  const [lists, setLists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [quickAdd, setQuickAdd] = useState();
  const user = JSON.parse(localStorage.getItem("user"));

  const getLists = async (jwt) => {
    setLoading(true);
    try {
      const lists = await getAllLists(jwt);
      setLists(lists.data.data.lists);
    } catch (e) {
      logout();
      navigate("/signin");
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!document.cookie || !user) {
      navigate("/signin");
    }
    getLists(getCookie());
  }, []);

  return (
    <>
      <Nav loading={loading} />
      <div id="dashboard-container">
        {loading ? (
          <>
            <Skeleton width="20rem" height="27rem" />
          </>
        ) : (
          <div id="lists-container-dashboard">
            {success && (
              <Snackbar open={true} autoHideDuration={6000}>
                <Alert severity="success">{success}</Alert>
              </Snackbar>
            )}
            {lists.map((list) => {
              let listType;
              switch (list.type) {
                case "RegularList":
                  listType = (
                    <RegularList
                      key={list._id}
                      listId={list._id}
                      list={list}
                      items={list.items}
                      needAccept={list.needAccept}
                    />
                  );
                  break;
                case "pointLeaderboard":
                  listType = <PointLeaderboard />;
                  break;
                default:
                  listType = (
                    <RegularList
                      key={list._id}
                      list={list}
                      listId={list._id}
                      items={list.items}
                      needAccept={list.needAccept}
                    />
                  );
                  break;
                case "pointLeaderboard":
                  listType = <PointLeaderboard />;
                  break;
              }
              return <div key={list.id}>{listType}</div>;
            })}
            {user.familyId && <PointLeaderboard />}
            <QuickNotes />
            {user.familyId && (
              <TaskManagerList
                setQuickAdd={setQuickAdd}
                setSelected={() => navigate("/dashboard/family/taskmanagment")}
              />
            )}
          </div>
        )}
        {quickAdd && (
          <Backdrop open={true} id="full-backdrop">
            <QuickAdd
              setQuickAdd={setQuickAdd}
              list={quickAdd}
              forceNeedAccept={true}
            />
          </Backdrop>
        )}
        {/* {loading && (
          <Backdrop open="open" className="backdrop">
            <CircularProgress color="primary" />
          </Backdrop>
        )} */}
      </div>
    </>
  );
};
